module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAPUlEQVR42mMY0cC7wfs/TthAmpYG0mxpIM1hDaT5pYE07zcQHWIQDUAGVTWMagjzfgnSQIoWMe9VwzdnAgBMaWbsqEXQpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter-24.png
// module id = CIWm
// module chunks = 1